module.exports = __webpack_public_path__ + "static/img/21.9e74633.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/21.jpg
// module id = znXo
// module chunks = 1